export default __webpack_public_path__ + "static/media/mail_dark_red.b98fba00.svg";